// removed by extract-text-webpack-plugin
module.exports = {"miniProgress":"miniProgress___HYR82","progressWrap":"progressWrap___3LNsh","progress":"progress___3GIZY","target":"target___3bu3J"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/MiniProgress/index.less
// module id = 424
// module chunks = 0 1